/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { AxiosResponse } from 'axios';
import apiClient from '../../../services/api-client';
import { ActivitiesResponse, CreateOrUpdateActivityPayload, LookupsResponse } from './types/types';

export async function getActivities(accountId: string): Promise<AxiosResponse<ActivitiesResponse>> {
  // note at this stage we do not support pagination for activities so that is why are are hard coding these values
  return await apiClient.get<ActivitiesResponse, void>(
    `/v1/activities?accountNumber=${accountId}&pageSize=50`,
  );
}

export async function getActivitiesLookups(): Promise<AxiosResponse<LookupsResponse>> {
  return await apiClient.get<LookupsResponse, void>('/v1/activity-lookups');
}

export async function createActivity(
  payload: CreateOrUpdateActivityPayload,
): Promise<AxiosResponse<string>> {
  return await apiClient.post<string, CreateOrUpdateActivityPayload>('/v1/activities', payload);
}

export async function editActivity(
  payload: CreateOrUpdateActivityPayload,
): Promise<AxiosResponse<string>> {
  return await apiClient.put<string, CreateOrUpdateActivityPayload>(
    `/v1/activities/${payload.activityId}`,
    payload,
  );
}
